import styled from 'styled-components';
import base from '@sizeid/commons/utils/base';
import { media } from '@sizeid/commons/utils/styles';

import ContentWhiteBox from '../..';

export default styled(ContentWhiteBox)`
  margin-top: ${base(0.5)};

  iframe,
  video {
    margin-bottom: 20px;
  }

  > p {
    margin: 0 0 ${base(1.5)};
  }

  > div {
    margin-top: ${base(1)};

    > span {
      display: inline-block;
      padding-top: 15px;

      ${media.moreThan('sm')`
        padding-top: 0;
        text-align: right;
      `};

      > img {
        width: 50%;
      }
    }

    p {
      margin: 0;
    }
  }

  a > svg {
    margin-left: 5px;
  }

  ${media.moreThan('sm')`
    margin-top: 40px;
    text-align: left;

    > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .logo-footer {
      p, span {
        max-width: 50%;
      }
    }
  `};

  ${media.lessThan('sm')`
    > div {
      margin-top: ${base(1.5)};
    }
  `};
`;
